import React from 'react';

import { Box, TableRow, TableCell, Typography } from '@mui/material';

const styles: React.CSSProperties = {
  display: 'flex',
  position: 'absolute',
  top: '40%',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
};

interface Props {
  message?: string;
  colSpan?: number;
  center?: boolean;
}

const NoResults = ({ message, colSpan, center }: Props) => {
  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        align="center"
        style={{
          border: 'none',
          color: 'inherit',
        }}
      >
        <Box style={center ? styles : undefined}>
          <Typography align="center">
            {message || 'No se encontraron resultados'}
          </Typography>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default NoResults;
